import { useState, useEffect, useContext } from 'react';
import { uploadFile } from '../../API/Api';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';
import { useForm } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SearchIcon from '@mui/icons-material/Search';
import { TokenContext } from '../../App';
import { Tooltip } from '@mui/material';
import { sendEmailNotification, getCompanyDetails } from '../../API/Api';
import CryptoJS from 'crypto-js';

export function RightContainer({ children, className }) {
  return (
    <div className='flex-1 ml-80 px-9 pt-4 max-w-screen-2xl h-screen'>
      {/* <div className='flex-1 ml-80 px-9 pt-4 overflow-x-auto max-w-screen-2xl'> */}
      {children}
      {/* h-screen was what made it flexible omg lol. */}
    </div>
  );
}

export function Card({ children, className }) {
  return <div className={`bg-white rounded-sm shadow-md p-4 mb-4 mx-2 ${className}`}>{children}</div>;
}

export function Row({ children, className }) {
  return <div className={`flex flex-row justify-between ${className}`}>{children}</div>;
}

export function CustomTooltip({ title, className }) {
  return (
    <Tooltip
      title={<p>{title}</p>}
      componentsProps={{
        tooltip: {
          sx: { maxWidth: '600px', fontSize: '14px' },
        },
      }}
    >
      <span className={`text-xl relative ${className}`}> ⓘ </span>
    </Tooltip>
  );
}

// ------------------- forms utils ----------------------

export function UploadFileInput({
  watch,
  register,
  setValue,
  formDisplayName,
  azureFileName,
  formName,
  readOnly = false,
  customName,
  className,
  token,
}) {
  const watchedValue = watch(formName); // this is actual name of file
  const [fileName, setFileName] = useState(azureFileName);

  const handleFileUpload = async (e, fileType) => {
    // const fileInputFieldName = e.target.name;

    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (!watchedValue) {
      setValue(formName, ' ');
    }

    try {
      const data = new FormData();
      data.append('file', file);
      const fileNewName = `${fileType}_${file.name}`;

      const res = await uploadFile(data, fileNewName);
      setFileName(fileNewName);
      setValue(formName, res.data.url);
    } catch (e) {
      setFileName('');
      setValue(formName, '');
      toast.error('Invalid file type!');
    }
  };

  const handleFileRemove = async fileName => {
    setValue(formName, '');
  };

  return (
    <div className={`${className}`}>
      <p className='text-sm font-medium text-gray-700 mb-2'> {formDisplayName} </p>
      {watchedValue && watchedValue[0] && typeof watchedValue === 'string' && (
        <p className=' mb-2'>
          <a
            href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${azureFileName}&accessToken=${token}`}
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-600 mb-2'
          >
            {decodeURIComponent(watchedValue?.split('/')?.slice(-1)[0] || ' ')}
          </a>
          <span className='cursor-pointer' onClick={() => handleFileRemove(formName)}>
            {' '}
            ❌{' '}
          </span>
        </p>
      )}
      <label className={`bg-gray-200 px-3 py-1 mt-5 rounded ${!readOnly && 'cursor-pointer'}`}>
        {customName ? customName : 'Browse'}
        <input
          maxLength={800}
          {...register(formName, {
            onChange: e => {
              handleFileUpload(e, formName);
            },
          })}
          disabled={readOnly}
          type='file'
          name={formName}
          className='hidden'
        />
      </label>
    </div>
  );
}

export function CommentSection({
  parentFormId,
  formName,
  disabled,
  pastComments = [],
  submitFormComment,
  readOnly = false,
}) {
  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);
  // zod check if comment string is blank, deny it otherwise

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      comment: '',
      commentId: '' || uuidv4(),
      commentorName: decodedToken.name,
      createdAt: '' || DateTime.now().toFormat('dd-MM-yyyy HH:mm'),
      parentFormId: parentFormId,
    },
    //  append to comments: [], must follow above convention
  });

  const onSubmit = async commentData => {
    if (Array.isArray(commentData?.comment) || commentData?.comment?.trim() === '') {
      return;
    }

    submitFormComment(commentData);
    setValue('comment', []); // RHF, reset() works on ALL fields, hence to reset only 1 field, setValue instead
  };

  return (
    <div className='font-semibold mb-1 w-full'>
      Comments:
      {pastComments.map(comment => (
        // {allComments.map( (comment) => (
        // {value.comments.map( (comment) => (
        <div className='my-1 p-1.5 border-b'>
          <p className='text-xs underline font-normal flex justify-between'>
            <span> {comment?.commentorName}: </span> {comment?.createdAt}
          </p>
          <p className='w-full text-sm break-words'>{comment?.comment}</p>
        </div>
      ))}
      <div className='flex'>
        <input
          maxLength={800}
          {...register('comment')}
          placeholder='Write comment'
          disabled={disabled}
          className='w-11/12 p-1 font-normal border-b-2 border-b-gray-300 bg-gray-50 focus:outline-none focus:border-green-500'
        />
        {/* <input maxLength={800} placeholder="Write comment" name={inputName} value={value?.newComment} onChange={(e) => handleInputChange(e, 'newComment')} className="w-11/12 p-1 font-normal border-b-2 border-b-gray-300 bg-gray-50 focus:outline-none focus:border-green-500"/> */}
        {/* <span className='cursor-pointer'> */}
        <span onClick={handleSubmit(onSubmit)} className={`${!disabled && 'cursor-pointer'}`}>
          {/* <span onClick={(e) => handleSubmitComment(e, 'newComment', inputName)} className='cursor-pointer'> */}
          <svg
            width='32px'
            height='32px'
            viewBox='-6.24 -6.24 36.48 36.48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            stroke='#ffffff'
          >
            <g id='SVGRepo_bgCarrier' strokeWidth='0' transform='translate(0,0), scale(1)'>
              <rect x='-6.24' y='-6.24' width='36.48' height='36.48' rx='18.24' fill='#25e44b' strokeWidth='0' />{' '}
            </g>
            <g
              id='SVGRepo_tracerCarrier'
              strokeLinecap='round'
              strokeLinejoin='round'
              stroke='#CCCCCC'
              strokeWidth='0.288'
            />
            <g id='SVGRepo_iconCarrier'>
              {' '}
              <path
                d='M3 7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2Z'
                stroke='#f7f7f7'
                strokeWidth='2.4'
                strokeLinecap='round'
                strokeLinejoin='round'
              />{' '}
            </g>
          </svg>
        </span>
      </div>
    </div>
  );
}

//  multi select where options are array of strings
export function CheckboxesTags({ field, allOptions, label }) {
  const [selectedOptions, setSelectedOptions] = useState([...(field.value || [])]);
  const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
  const checkedIcon = <CheckBoxIcon fontSize='small' />;

  const handleInputChange = (event, newInputValue) => {
    if (event && event.type === 'keydown' && event.key === 'Enter' && newInputValue) {
      const trimmedInput = newInputValue.trim();
      if (trimmedInput && !selectedOptions.includes(trimmedInput)) {
        const updatedOptions = [...selectedOptions, trimmedInput];
        setSelectedOptions(updatedOptions);
        field.onChange(updatedOptions);
      }
    }
  };

  // Combine original options with newly added options
  const combinedOptions = [...new Set([...allOptions, ...selectedOptions])];

  return (
    <div className='flex'>
      <Autocomplete
        {...field}
        multiple
        freeSolo
        size='small'
        id='checkboxes-tags-demo'
        disableCloseOnSelect
        options={combinedOptions}
        getOptionLabel={option => option}
        isOptionEqualToValue={(option, value) => option === value}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
              {option}
            </li>
          );
        }}
        style={{ width: '100%' }}
        renderInput={params => <TextField {...params} label={label} placeholder='' />}
        onChange={(_, data) => {
          setSelectedOptions(data);
          field.onChange(data);
        }}
        onInputChange={handleInputChange}
      />

      <Tooltip
        title={<p> Type custom value and press enter to save. </p>}
        arrow
        componentsProps={{
          tooltip: {
            sx: { maxWidth: '600px', fontSize: '14px' },
          },
        }}
      >
        <span className='text-xl relative bottom-0.5 ml-2 mt-1.5'> ⓘ </span>
      </Tooltip>
    </div>
  );
}

export async function notifyUser(formData, userName, userEmail) {
  sendEmailNotification({
    email: userEmail,
    subject: `KYC Form Completed - ${formData.name}`,
    message: `
      <div style="max-width: 600px; margin: 0 auto; border: 2px solid #FF8C00; padding: 20px; text-align: center;">
        <h1 style="margin-bottom: 20px; text-decoration: underline;">KYC Form Completed - ${formData.name}</h1>
        <p> Dear ${userName} </p>
        <p> The client detail form for ${formData.name} has been completed.</p>
        <p> Please log in to the iCOMPASS platform to review the submitted information. </p>
        <img src="https://icompass-backend-dev-fhagh5hccpf2ebh9.southeastasia-01.azurewebsites.net/images/from_icompass" alt="iCOMPASS logo" style="display: block; margin: 20px auto; width: 200px; height: auto; max-width: 100%;">
        <p style="font-style: italic; margin-top: 20px;">Please do not reply to this email</p>
      </div> `,
  });
}

const secret_key = CryptoJS.enc.Utf8.parse('iCompassiCompass'); //16字节（128位）密钥
const iv_key = CryptoJS.enc.Utf8.parse('caglobe@caglobe@'); //十六位十六进制数作为密钥偏移量

export function encrypt(words) {
  const srcs = CryptoJS.enc.Utf8.parse(words);
  const encrypted = CryptoJS.AES.encrypt(srcs, secret_key, {
    iv: iv_key,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

export function decrypt(words) {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(words);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, secret_key, {
    iv: iv_key,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

/**
 * 规范化用户输入的空格
 * 将多个连续空格替换为单个空格，并去除首尾空格
 * @param {string} input - 用户输入的字符串
 * @returns {string} - 规范化后的字符串
 */
export function normalizeSpaces(input) {
  if (!input || typeof input !== 'string') {
    return '';
  }

  // 将多个连续空格（包括制表符、换行符等空白字符）替换为单个空格
  // 然后去除首尾空格
  return input.replace(/\s+/g, ' ').trim();
}

/**
 * 解析 kycSettings.nextResetDate
 * 兼容 dd-MM-yyyy / yyyy-MM-dd / yyyy.M.d（含单位数月日）格式
 * @param {string} value - 日期字符串
 * @returns {DateTime|null} - 解析失败返回 null
 */
function parseKycResetDate(value) {
  if (!value || typeof value !== 'string') {
    return null;
  }
  let parsed = null;
  if (value.includes('-')) {
    parsed =
      value.split('-')[0].length === 4
        ? DateTime.fromFormat(value, 'yyyy-M-d')
        : DateTime.fromFormat(value, 'd-M-yyyy');
  } else if (value.includes('.')) {
    parsed = DateTime.fromFormat(value, 'yyyy.M.d');
  }
  return parsed && parsed.isValid ? parsed : null;
}

/**
 * 判断公司 kycSettings 的订阅是否已到期（nextResetDate 已过）
 * apiRateLimit 未配置或为负数（无限额度）时视为未到期
 * @param {object} kycSettings - 公司的 kycSettings
 * @returns {boolean}
 */
export function isKycSettingsExpired(kycSettings) {
  const rateLimitConfigured =
    kycSettings && kycSettings.apiRateLimit !== undefined && kycSettings.apiRateLimit !== null;
  if (!rateLimitConfigured) {
    return false;
  }
  const apiRateLimit = parseInt(kycSettings.apiRateLimit);
  if (isNaN(apiRateLimit) || apiRateLimit < 0) {
    return false;
  }
  const resetDate = parseKycResetDate(kycSettings.nextResetDate);
  return !!(resetDate && resetDate <= DateTime.now());
}

/**
 * 请求公司详情并判断订阅是否已到期（供登录后全局提示等场景使用）
 * @returns {Promise<boolean>}
 */
export async function isKycSubscriptionExpired() {
  try {
    const respons = await getCompanyDetails('company');
    return isKycSettingsExpired(respons.data?.kycSettings);
  } catch (error) {
    console.error('订阅到期检查失败:', error);
    return false;
  }
}

/**
 * 检查API调用配额是否超出限制（含订阅到期检查）
 * @param {Function} setShowQuotaModal - 设置显示配额模态框的函数，会被传入 'expired'（订阅到期）或 true（额度用完）
 * @param {string} [excludeCompanyId] - 需要排除检查的公司ID（如 '500-global'）
 * @returns {Promise<boolean>} - 返回true表示不允许筛查，false表示允许
 */
export async function checkAPICallsQuota(setShowQuotaModal, excludeCompanyId = null) {
  try {
    const respons = await getCompanyDetails('company');
    const companyData = respons.data;

    // 如果指定了排除的公司ID，则跳过检查
    if (excludeCompanyId && companyData?.companyId === excludeCompanyId) {
      return false;
    }

    const kycSettings = companyData?.kycSettings;

    // 订阅到期检查：nextResetDate 已过即到期
    if (isKycSettingsExpired(kycSettings)) {
      setShowQuotaModal('expired');
      return true;
    }

    const apiCallsUsed = parseInt(kycSettings?.apiCallsUsed || 0);
    const apiRateLimit = parseInt(kycSettings?.apiRateLimit || 0);

    if (apiCallsUsed >= apiRateLimit) {
      setShowQuotaModal(true);
      return true;
    }

    return false;
  } catch (error) {
    console.error('配额检查失败:', error);
    return false;
  }
}
